<template>
  <!--Team start-->
  <section class="theme-bg-gray " id="glorifying_person">
    <div class="animation-circle">
      <i></i>
      <i></i>
      <i></i>
    </div>
    <div class="container">
      <div class="row">
        <div class="col-md-12 text-center">
          <div class="section-title">
            <h2 class="text-green">
              กยท. เชิดชูคนดีมีคุณธรรมของพนักงานและลูกจ้าง ปี 2564
            </h2>
            <img
              :src='"../assets/images/green-line.png"'
              alt="title-line"
              class="img-fluid"
            />
          </div>
        </div>
        <div class="col-md-12">
          <carousel
            v-bind:class="'team-slider'"
            :margin="15"
            :loop="true"
            :items="3"
            :nav="false"
            :autoplayTimeout="2000"
            :autoplayHoverPause="true"
            :dots="true"
            :dotsEach="false"
            :autoplay="false"
            :responsive="{
              0: { items: 1 },
              576: { items: 2, margin: 12 },
              600: { items: 2 },
              767: { items: 2 },
              768: { items: 2, margin: 15 },
              992: { items: 3 },
              1000: { items: 3 },
            }"
          >
            <div class="item">
              <div class="team-box">
                <div class="team-under-box">
                  <div class="team-under-box-button text-white">
                    <i class="fa fa-eye" aria-hidden="true"></i>
                  </div>
                  <img
                    :src='"../assets/images/emp-1.jpeg"'
                    alt="1"
                    class="img-fluid"
                  />
                </div>
              </div>
            </div>
            <div class="item">
              <div class="team-box">
                <div class="team-under-box2">
                  <div class="team-under-box-button text-white">
                    <i class="fa fa-eye" aria-hidden="true"></i>
                  </div>
                  <img
                    :src='"../assets/images/emp-2.jpeg"'
                    alt="2"
                    class="img-fluid"
                  />
                </div>
              </div>
            </div>
            <div class="item">
              <div class="team-box">
                <div class="team-under-box3">
                  <div class="team-under-box-button text-white">
                    <i class="fa fa-eye" aria-hidden="true"></i>
                  </div>
                  <img
                    :src='"../assets/images/emp-3.jpeg"'
                    alt="3"
                    class="img-fluid"
                  />
                </div>
              </div>
            </div>
            <div class="item">
              <div class="team-box">
                <div class="team-under-box4">
                  <div class="team-under-box-button text-white">
                    <i class="fa fa-eye" aria-hidden="true"></i>
                  </div>
                  <img
                    :src='"../assets/images/emp-4.jpeg"'
                    alt="3"
                    class="img-fluid"
                  />
                </div>
              </div>
            </div>
            <div class="item">
              <div class="team-box">
                <div class="team-under-box5">
                  <div class="team-under-box-button text-white">
                    <i class="fa fa-eye" aria-hidden="true"></i>
                  </div>
                  <img
                    :src='"../assets/images/emp-5.jpeg"'
                    alt="3"
                    class="img-fluid"
                  />
                </div>
              </div>
            </div>
            <div class="item">
              <div class="team-box">
                <div class="team-under-box6">
                  <div class="team-under-box-button text-white">
                    <i class="fa fa-eye" aria-hidden="true"></i>
                  </div>
                  <img
                    :src='"../assets/images/emp-6.jpeg"'
                    alt="3"
                    class="img-fluid"
                  />
                </div>
              </div>
            </div>
          </carousel>
        </div>
        <div class="col-md-12">
          <div class="team-hover">
            <div class="row">
              <div class="col-md-4">
                <div class="team-profile">
                  <img
                   :src='"../assets/images/emp-1.jpeg"'
                    alt="1"
                    class="img-fluid"
                  />
                </div>
              </div>
              <div class="col-md-8">
                <div class="d-flex-0 mt-1">
                  <div class="hover-text">
                    <div class="team-close-btn">
                      <a><i class="fa fa-times" aria-hidden="true"></i></a>
                    </div>
                    <h3>นางแพรวพรรณ ทองนุ่น</h3>
                    <h4 class="text-black">
                      หัวหน้าแผนกแผนงานและข้อมูล /
                      การยางแห่งประเทศไทยจังหวัดตรัง
                    </h4>
                    <p class="mt-2">
                      เป็นผู้ให้คำแนะนำแก่พนักงาน กยท. ในด้านต่างๆ เช่น
                      ด้านแผนงานและข้อมูล งานด้านบริหารความเสี่ยงและควบคุมภายใน
                      การจัดทำบันทึกข้อตกลง (MOU) ฯลฯ
                      และได้รับมอบหมายให้เป็นผู้ปฏิบัติงานสำคัญต่างๆ ขององค์กร
                      เช่น เป็นวิทยาการโครงการฝึกอบรมพนักงาน
                      เป็นผู้อภิปรายในเวทีเสวนา
                      และเป็นพิธีกรหลักและพิธีกรร่วมในงานระดับองค์กร
                    </p>
                       <p class="mt-2">
                      <b-row>
                          <b-col sm="4" md="4" cols="4" >
                            <img
                    :src='"../assets/images/emp1-1.jpg"'
                    alt="1"
                    class="img-fluid"
                  />
                       </b-col>
                           <b-col sm="4" md="4" cols="4" >
                            <img
                    :src='"../assets/images/emp1-2.jpg"'
                    alt="1"
                    class="img-fluid"
                  />
                       </b-col>
                           <b-col sm="4" md="4" cols="4" >
                            <img
                    :src='"../assets/images/emp1-3.jpg"'
                    alt="1"
                    class="img-fluid"
                  />
                       </b-col>
                      
                      </b-row>
                    </p>

                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="team-hover2">
            <div class="row">
              <div class="col-md-4">
                <div class="team-profile">
                  <img
                    :src='"../assets/images/emp-2.jpeg"'
                    alt="1"
                    class="img-fluid"
                  />
                </div>
              </div>
              <div class="col-md-8">
                <div class="d-flex-0 mt-1">
                  <div class="hover-text">
                    <div class="team-close-btn">
                      <a><i class="fa fa-times" aria-hidden="true"></i></a>
                    </div>
                    <h3>นางสาวอัจฉรา เพียรธัญกรณ์ </h3>
                    <h4 class="text-black">นักวิชาการเงินและบัญชี 6 / การยางแห่งประเทศไทยจังหวัดอุทัยธานี 
                    </h4>
                    <p class="mt-2">
                      
	เป็นผู้ปฏิบัติงานด้วยความมุ่งมั่นตั้งใจทั้งงานในหน้าที่และงานที่ได้รับมอบหมายเพิ่มเติมตามหลักธรรมาภิบาล วางแผนการบริหารงานอย่างเป็นระบบ ผลงานมีความถูกต้อง ทันเวลา และมีคุณภาพเป็นที่น่าพอใจของหน่วยงานภายในและภายนอก สามารถให้คำแนะนำพร้อมทั้งร่วมแก้ไขปัญหากับผู้ร่วมงาน และเกษตรกรชาวสวนยางอย่างเต็มใจเพื่อให้เกิดประโยชน์สูงสุด

                    </p>
                     <p class="mt-2">
                      <b-row>
                          <b-col sm="4" md="4" cols="4" >
                            <img
                    :src='"../assets/images/emp2-1.jpg"'
                    alt="1"
                    class="img-fluid"
                  />
                       </b-col>
                           <b-col sm="4" md="4" cols="4" >
                            <img
                    :src='"../assets/images/emp2-2.jpg"'
                    alt="1"
                    class="img-fluid"
                  />
                       </b-col>
                           <b-col sm="4" md="4" cols="4" >
                            <img
                    :src='"../assets/images/emp2-3.jpg"'
                    alt="1"
                    class="img-fluid"
                  />
                       </b-col>
                      
                      </b-row>
                    </p>
                     
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="team-hover3">
            <div class="row">
              <div class="col-md-4">
                <div class="team-profile">
                  <img
                    :src='"../assets/images/emp-3.jpeg"'
                    alt="1"
                    class="img-fluid"
                  />
                </div>
              </div>
              <div class="col-md-8">
                <div class="d-flex-0 mt-1">
                  <div class="hover-text">
                    <div class="team-close-btn">
                      <a><i class="fa fa-times" aria-hidden="true"></i></a>
                    </div>
                   <h3>นางสุภาภรณ์ สายบัว</h3>
                    <h4 class="text-black">เจ้าหน้าที่บริหารงานทั่วไป 6 / การยางแห่งประเทศไทยจังหวัดอุบลราชธานี
                    </h4>
                    <p class="mt-2">
                     
	เป็นผู้มีความขยันหมั่นเพียร วิริยะอุตสาหะ และทุ่มเทในการทำงานด้วยความซื่อสัตย์สุจริต มีมนุษยสัมพันธ์ที่ดีต่อผู้อื่น มีความรับผิดชอบในงานที่ได้รับมอบหมาย ปฏิบัติงานตรงตามหลักเกณฑ์ กฎ ระเบียบที่มีการกำหนดโดยถือประโยชน์ของส่วนรวมและองค์กรเป็นที่ตั้ง และเป็นผู้ที่มีความสุขในการทำงาน 

                    </p>
                     <p class="mt-2">
                      <b-row>
                          <b-col sm="4" md="4" cols="4" >
                            <img
                    :src='"../assets/images/emp3-1.jpg"'
                    alt="1"
                    class="img-fluid"
                  />
                       </b-col>
                           <b-col sm="4" md="4" cols="4" >
                            <img
                    :src='"../assets/images/emp3-2.jpg"'
                    alt="1"
                    class="img-fluid"
                  />
                       </b-col>
                           <b-col sm="4" md="4" cols="4" >
                            <img
                    :src='"../assets/images/emp3-3.jpg"'
                    alt="1"
                    class="img-fluid"
                  />
                       </b-col>
                      
                      </b-row>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="team-hover4">
            <div class="row">
              <div class="col-md-4">
                <div class="team-profile">
                  <img
                    :src='"../assets/images/emp-4.jpeg"'
                    alt="1"
                    class="img-fluid"
                  />
                </div>
              </div>
              <div class="col-md-8">
                <div class="d-flex-0 mt-1">
                  <div class="hover-text">
                    <div class="team-close-btn">
                      <a><i class="fa fa-times" aria-hidden="true"></i></a>
                    </div>
                    <h3>นายภุชงค์ ฉันทศิริรัตน์</h3>
                    <h4 class="text-black">นักวิชาการส่งเสริมการเกษตร 6 / การยางแห่งประเทศไทยสาขาเมืองยะลา
                    </h4>
                    <p class="mt-2">
                      
	เป็นผู้ปฏิบัติงานตามระเบียบขององค์กรอย่างเคร่งครัด และปฏิบัติหน้าที่ตามที่ได้รับมอบหมายให้สำเร็จลุล่วงไปได้ด้วยดี มีความขยันหมั่นเพียร ไม่ย่อท้อต่องาน มีมนุษยสัมพันธ์อันดีกับผู้มีส่วนได้ส่วนเสียขององค์กร มีความรับผิดชอบ ชอบช่วยเหลือสังคม และเป็นผู้มีความคิดความสร้างสรรค์ หมั่นศึกษาหาความรู้ให้ตนเองอยู่เสมอ 

                    </p>
                     <p class="mt-2">
                      <b-row>
                          <b-col sm="4" md="4" cols="4" >
                            <img
                    :src='"../assets/images/emp4-1.jpg"'
                    alt="1"
                    class="img-fluid"
                  />
                       </b-col>
                           <b-col sm="4" md="4" cols="4" >
                            <img
                    :src='"../assets/images/emp4-2.jpg"'
                    alt="1"
                    class="img-fluid"
                  />
                       </b-col>
                           <b-col sm="4" md="4" cols="4" >
                            <img
                    :src='"../assets/images/emp4-3.jpg"'
                    alt="1"
                    class="img-fluid"
                  />
                       </b-col>
                      
                      </b-row>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="team-hover5">
            <div class="row">
              <div class="col-md-4">
                <div class="team-profile">
                  <img
                    :src='"../assets/images/emp-5.jpeg"'
                    alt="1"
                    class="img-fluid"
                  />
                </div>
              </div>
              <div class="col-md-8">
                <div class="d-flex-0 mt-1">
                  <div class="hover-text">
                    <div class="team-close-btn">
                      <a><i class="fa fa-times" aria-hidden="true"></i></a>
                    </div>
                    <h3>นายธีรศักดิ์ ต๊ะอ๊อด</h3>
                    <h4 class="text-black">ผู้อำนวยการการยางแห่งประเทศไทยสาขาสุโขทัย / การยางแห่งประเทศไทยจังหวัดตาก
                    </h4>
                    <p class="mt-2">
                      
	เป็นผู้มีผลงานเป็นที่ประจักษ์ทั้งภายในและภายนอกขององค์กร และได้มอบหมายให้ปฏิบัติงานที่สำคัญอันเป็นประโยชน์แก่ส่วนรวม ได้แก่ การเป็นวิทยากรบรรยาย และออกปฏิบัติงานช่วยเหลือสังคมในรูปแบบจิตอาสาอย่างต่อเนื่อง จนได้รับเกียรติบัตรและหนังสือขอบคุณจากหน่วยงานต่างๆ ตลอดมา

                    </p>
                     <p class="mt-2">
                      <b-row>
                          <b-col sm="4" md="4" cols="4" >
                            <img
                    :src='"../assets/images/emp5-1.jpg"'
                    alt="1"
                    class="img-fluid"
                  />
                       </b-col>
                           <b-col sm="4" md="4" cols="4" >
                            <img
                    :src='"../assets/images/emp5-2.jpg"'
                    alt="1"
                    class="img-fluid"
                  />
                       </b-col>
                           <b-col sm="4" md="4" cols="4" >
                            <img
                    :src='"../assets/images/emp5-3.jpg"'
                    alt="1"
                    class="img-fluid"
                  />
                       </b-col>
                      
                      </b-row>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="team-hover6">
            <div class="row">
              <div class="col-md-4">
                <div class="team-profile">
                  <img
                    :src='"../assets/images/emp-6.jpeg"'
                    alt="1"
                    class="img-fluid"
                  />
                </div>
              </div>
              <div class="col-md-8">
                <div class="d-flex-0 mt-1">
                  <div class="hover-text">
                    <div class="team-close-btn">
                      <a><i class="fa fa-times" aria-hidden="true"></i></a>
                    </div>
                    <h3>นายอานุภาพ จิตรเที่ยง</h3>
                    <h4 class="text-black">พนักงานควบคุมยานพาหนะ / การยางแห่งประเทศไทยสาขาย่านตาขาว 
                    </h4>
                    <p class="mt-2">
                      
เป็นผู้มุ่งมั่นในการปฏิบัติงานจนเป็นที่ยอมรับของผู้บังคับบัญชาและเพื่อนร่วมงาน มีความสามารถในประสานงานเรื่องต่างๆ กับหน่วยงานภายนอกได้ดี มีอัธยาศัยดี มารยาทดี มีความอ่อนน้อมถ่อมตน ชอบช่วยเหลือปฏิบัติงานส่วนรวมขององค์กรอย่างเต็มที่และเต็มใจ ปฏิบัติงานตามกฎระเบียบและข้อบังคับขององค์กรอย่างเคร่งครัดด้วยความซื่อสัตย์สุจริต

                    </p>
                     <p class="mt-2">
                      <b-row>
                          <b-col sm="4" md="4" cols="4" >
                            <img
                    :src='"../assets/images/emp6-1.jpg"'
                    alt="1"
                    class="img-fluid"
                  />
                       </b-col>
                           <b-col sm="4" md="4" cols="4" >
                            <img
                    :src='"../assets/images/emp6-2.jpg"'
                    alt="1"
                    class="img-fluid"
                  />
                       </b-col>
                           <b-col sm="4" md="4" cols="4" >
                      
                       </b-col>
                      
                      </b-row>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!--Team end -->
</template>
<script>
import $ from "jquery";
export default {
  name: "Team",
  mounted() {
    this.loader();
  },
  methods: {
    loader() {
      $("#hide").on("click", function(event) {
        $("p").hide();
      });
      $("#show").on("click", function(event) {
        $("p").show();
      });
      $(".team-hover").hide();
      $(".team-hover2").hide();
      $(".team-hover3").hide();
      $(".team-hover4").hide();
      $(".team-hover5").hide();
      $(".team-hover6").hide();

      $(".team-under-box").on("click", function(event) {
        $(".team-box").hide(1000);
        $(".team-hover").show(1000);
        $(".team-hover").fadeIn("slow");
      });

      $(".team-under-box2").on("click", function(event) {
        $(".team-box").hide(1000);
        $(".team-hover2").show(1000);
        $(".team-hover2").fadeIn("slow");
      });

      $(".team-under-box3").on("click", function(event) {
        $(".team-box").hide(1000);
        $(".team-hover3").show(1000);
        $(".team-hover3").fadeIn("slow");
      });

      $(".team-under-box4").on("click", function(event) {
        $(".team-box").hide(1000);
        $(".team-hover4").show(1000);
        $(".team-hover4").fadeIn("slow");
      });

      $(".team-under-box5").on("click", function(event) {
        $(".team-box").hide(1000);
        $(".team-hover5").show(1000);
        $(".team-hover5").fadeIn("slow");
      });

      $(".team-under-box6").on("click", function(event) {
        $(".team-box").hide(1000);
        $(".team-hover6").show(1000);
        $(".team-hover6").fadeIn("slow");
      });

      $(".team-close-btn").on("click", function(event) {
        $(".team-hover").hide(1000);
        $(".team-hover2").hide(1000);
        $(".team-hover3").hide(1000);
        $(".team-hover4").hide(1000);
        $(".team-hover5").hide(1000);
        $(".team-hover6").hide(1000);
        $(".team-box").show(1000);
        $(".team-box").fadeIn("slow");
      });
    },
  },
};
</script>
